<template>
  <div class="stil-guides">
    <button v-if="isButton" @click="isShowGuide = true"><span class="icon-play"></span> Se guide til indberetningen
    </button>
    <p v-else class="text-link" @click="isShowGuide = true">{{ textForLink }}</p>
    <DModal :isBgOverlay="true" v-if="isShowGuide" @close="isShowGuide = false">
      <div class="d-embed" slot="insertComponent">
        <div class='d-embed-container'>
          <iframe :src="videoLink" title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import DModal from '../common/DModal'

export default {
  components: {DModal},
  props: {
    textForLink: {
      default: 'Guide: Se videoguide Her'
    },
    videoId: {
      default: 'etaeiteazYM'
    },
    isButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowGuide: false,
      playerVars: {
        autoplay: 1,
        resize: true,
        fitParent: true
      }
    }
  },
  computed: {
    videoLink () {
      return 'https://www.youtube.com/embed/' + this.videoId
    }
  },
  methods: {
    playing () {
      console.log('playing')
    }
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.text-link {
  color: var(--blue);
  cursor: pointer;
  display: inline-block;
}

.d-embed {
  width: 80vw;
  height: 80vh;
  max-width: 1224px;
}

.d-embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.d-embed-container iframe, .d-embed-container object, .d-embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// StilGuides.vue?27caf726